import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropertyDevelopersTable from '../../components/PropertyDevelopersTable';
import { upload } from '../../helpers/upLoadHelper';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectPropertyDevelopers } from '../../store/selectors/propertyDevelopers';
import { fetchContacts, saveContact,updateContact,deleteContactById, deletePropertyDeveloper } from '../../store/actions/contacts';
import { selectFormOptions } from '../../store/selectors/formOptions';
import { resetUserPassword,activateUser } from '../../store/actions/auth';
import { fetchPropertyManagersByPropertyId, fetchPropertyCounts,addExistingPropertyDeveloper } from '../../store/actions/properties';
import { setSearch } from '../../store/actions/search';
import { selectContacts } from '../../store/selectors/contacts';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';


class PropertyDevelopers extends Component {
    componentDidMount(){
        const { user, property, onFetchPropertyManagersByPropertyId,contacts } = this.props;
        if(contacts && contacts.length === 0){

        }
        onFetchPropertyManagersByPropertyId(property.propertyId)
    }
    onSubmitContactForm = async (data, actionType) => {
        const { user,property, onUpdateContactForm, onSubmitContactForm, onFetchPropertyCounts,onAddExistingPropertyDeveloper } = this.props;
        if(data.formType && data.formType === 'New'){

        
        let imageUrl=null
        if(data.selectedImage && data.selectedImage.length > 0){
          imageUrl =  await upload(data.selectedImage[0])
        }
        let assignedRoles = [];
        if(data.userRole){
          for (var i = 0; i < this.props.formOptions.allRoles.length; i++) {
            if (data.userRole === this.props.formOptions.allRoles[i].name) {
              assignedRoles.push(this.props.formOptions.allRoles[i].id)
            }
          }
        }
        if(!data.userRole){
          assignedRoles.push(data.roles[0].role.id)
        }
    
        let phone = data.phone;
        let cleaned = ('' + phone).replace(/\D/g, '');
        let formattedNumber = cleaned;
        if(cleaned.length  === 10){
          let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
          formattedNumber =   match[1] + '-' + match[2] + '-' + match[3];
        }
        let firstChar = data.firstname.charAt(0)?.toUpperCase();
        let slicedName = data.firstname.slice(1, data.firstname.length);
        let firstname = firstChar + slicedName
    
        let PropertyId = data.propertyId;
        if(data.id){
          let params ={
            "id": data.id,
           "username": data.username,
           "email": data.email,
           "firstname": firstname,
           "lastname": data.lastname,
           "phone": formattedNumber,
           "profileImage": imageUrl!= null ? imageUrl : data.profileImage,
           
           "languages": null,
           "customerId": null,
           "deleted": false,
           "assignedRoles": assignedRoles,
           "address":data.address,
           "UserId": user.id,
           "SendActivationLink":data.sendActivationEmail ? data.sendActivationEmail : false,
           "IsMultiSelect":false,
           "RoleName": data.userRole,
           "RoleId": assignedRoles[0]
          }
          
          if(data.userRole === 'Property Developer'){
              params.PropertyId = property.propertyId;
              params.isPrimaryContact = data && data.isPrimaryPropertyDeveloperContact && data.isPrimaryPropertyDeveloperContact === true ? true : false
              params.CalendarLink = data && data.calendarLink ? data.calendarLink.trim() : ''
            }
          if(data.userRole === 'Service Manager') {
            params.PropertyId = property.propertyId;
          }
          
          onUpdateContactForm(params,'FromPropertyDeveloper')
        }else{
          let params = {
            "username": data.email,
            "email": data.email,
            "firstname": firstname,
            "lastname": data.lastname,
            "phone": formattedNumber,
            "profileImage": imageUrl,
            
            "languages": null,
            "customerId": null,
            
            "SentEmail": true,
            "assignedRoles": assignedRoles,
            "address":data.address,
            "UserId": user.id,
            "SendActivationLink":data.sendActivationEmail ? data.sendActivationEmail : false,
            "IsMultiSelect":false,
            "RoleName": data.userRole,
            "RoleId": assignedRoles[0]
          }
          if(data.userRole === 'Property Developer') {
            params.PropertyId = property.propertyId;
            params.isPrimaryContact = data && data.isPrimaryContact && data.isPrimaryContact === true ? true : false
            params.CalendarLink = data && data.calendarLink ? data.calendarLink.trim() : ''
          }
          if(data.userRole === 'Service Manager') {
            params.PropertyId = property.propertyId;
          }
          
          await onSubmitContactForm(params,'FromPropertyDeveloper');
          onFetchPropertyCounts(this.props.property.propertyId, user.id, user.roles[0].role.name)
        }
      }else{
        let params={
          "PropertyId": property.propertyId,
          "PropertyManagerId": data.propertyManagerId,
          "UserId": user.id,
          "IsPrimaryContact": data.isPrimaryPropertyDeveloperContact && data.isPrimaryPropertyDeveloperContact === true ? true : false,
          "Role": data.userRole
        }
        onAddExistingPropertyDeveloper(params);
        onFetchPropertyCounts(property.propertyId, user.id, user.roles[0].role.name)

      }
      }

      onDeleteContactById = async (data) => {
        const { user, property, onDeletePropertyDeveloper, onFetchPropertyCounts,onFetchPropertyManagersByPropertyId } = this.props;

        await onDeletePropertyDeveloper(data.id, property.propertyId)
        onFetchPropertyCounts(property.propertyId, user.id, user.roles[0].role.name);
        onFetchPropertyManagersByPropertyId(property.propertyId);
      }

      sendActivationLinkToUser = data => {
        this.props.activateUser(data,{
          "UserId":data.id
        })
      }
    
      sendResetPasswordLinkToUser = data => {
       this.props.resetUserPassword(data)
      }
    render(){
        const { property, propertyDevelopers,setSearch,loader } = this.props;        
        return(
          loader ? <Loader /> :
            <PropertyDevelopersTable
                onSearch={e => setSearch({ propertyDevelopers: e.target.value.trim() })}
                propertyDevelopers={ propertyDevelopers }
                onSubmitContactForm={(data,actionType) => this.onSubmitContactForm(data,actionType)} 
                onDeleteContact={(data) => this.onDeleteContactById(data)}
                sendResetPasswordLinkToUser={ (data) =>this.sendResetPasswordLinkToUser(data)}
                sendActivationLinkToUser={(data) =>this.sendActivationLinkToUser(data)}
                propertyData={property}
            />
        )
    }

}

const mapStateToProps = state => ({
    user:selectAuthenticatedUser(state),
    propertyDevelopers:selectPropertyDevelopers(state),
    formOptions:selectFormOptions(state),
    contacts:selectContacts(state),
    loader: selectPRLoader(state),


});

const mapDispatchToProps = dispatch => bindActionCreators({
    onFetchPropertyManagersByPropertyId:fetchPropertyManagersByPropertyId,
    onSubmitContactForm: saveContact,
    onUpdateContactForm:updateContact,
    onDeleteContactById:deleteContactById,
    resetUserPassword:resetUserPassword,
    activateUser:activateUser,
    setSearch:setSearch,
    onDeletePropertyDeveloper: deletePropertyDeveloper,
    onFetchPropertyCounts: fetchPropertyCounts,
    onAddExistingPropertyDeveloper:addExistingPropertyDeveloper,
    onFetchContacts:fetchContacts
},dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PropertyDevelopers);